import { sv } from 'vuetify/locale';
import designerI18n from './designer-i18n.js';

export default {
    welcome: "Välkommen",
    login: "Logga in",
    logout: "Logga ut",
    about: "Om",
    dashboard: "Startsida",
    products: "Produkter",
    users: "Användare",
    labels: "Etiketter",
    createUser: "Skapa användare",
    editUser: "Redigera användare",
    deleteUser: "Ta bort användare",
    userList: "Användarlista",
    productList: "Produktlista",
    createProduct: "Skapa produkt",
    editProduct: "Redigera produkt",
    deleteProduct: "Ta bort produkt",
    labelSettings: "Etikettinställningar",
    createCategory: "Skapa kategori",
    editCategory: "Redigera kategori",
    deleteCategory: "Ta bort kategori",
    categoryList: "Kategorilista",
    dragToReorder: "Dra för att ändra ordning på kategorierna",
    name: "Namn",
    nameFormat: "Namn (Förnamn Efternamn)*",
    email: "E-post",
    emailFormat: "E-post*",
    role: "Är administratör",
    actions: "Åtgärder",
    save: "Spara",
    cancel: "Avbryt",
    edit: "Redigera",
    delete: "Ta bort",
    confirmDelete: "Är du säker på att du vill ta bort det här objektet?",
    yes: "Ja",
    no: "Nej",
    search: "Sök...",
    itemsPerPageText: "Objekt per sida:",
    pageText: "{0}-{1} av {2}",
    productName: "Produktnamn*",
    productNumber: "Produktnummer",
    productOnList: "Produktnamn",
    category: "Kategori",
    categoryOnList: "Kategori",
    categories: "Kategorier",
    noCategories: "Inga kategorier",
    thawingDays: "Upptining (dagar)",
    notesHint: "Ytterligare information om den här produkten",
    refridgeDays: "Kylskåp (dagar)",
    threeHoursHint: "Kan produkten stå framme i 3 timmar?",
    allergens: "Allergener",
    selectAllergens: "Välj allergener",
    noAllergens: "Inga allergener",
    notes: "Anteckning",
    daysUntilExpiration: "Dagar till utgång",
    daysNeededForThawing: "Dagar som krävs för upptining",
    daysInRefrigeration: "Dagar i kylskåp",
    producedDateLabel: "Tillverkningsdatum",
    openedDateLabel: "Öppnad datum",
    createdAt: "Skapad den",
    updatedAt: "Uppdaterad den",
    expirationDate: "Utgångsdatum",
    openedDate: "Öppnad datum",
    producedDate: "Tillverkningsdatum",     
    numLabels: "Antal etiketter",
    quantity: "Antal",
    foodItems: "Produkter",
    printSelected: "Skriv ut valda",
    mandatoryField: "anger ett obligatoriskt fält",
    categoryName: "Kategorinamn*",
    description: "Beskrivning",
    descriptionHint: "Radbrytning med Enter",
    standardCategory: "Standardkategori",
    fieldRequired: "Fältet är obligatoriskt",
    standard: "Standard",
    devices: "Enheter",
    deviceNick: "Enhetens smeknamn",
    deviceID: "Enhets-ID",
    confirmDeleteDevice: "Är du säker på att du vill ta bort enheten:",
    userAdministration: "Användaradministration",
    newPasswordOptional: "Nytt lösenord (valfritt)",
    passwordFormat: "Lösenord*",
    password: "Lösenord",
    admin: "Administratör",
    printFooditems: "Skriv ut etiketter",
    fromFooditems: "från livsmedel",
    loadingHomepage: "Laddar startsidan...",
    pleaseLogin: "Logga in för att komma åt startsidan",
    settings: "Inställningar",
    displaySettings: "Visningsinställningar",
    theme: "Tema",
    light: "Ljust",
    dark: "Mörkt",
    language: "Språk",  
    selectLanguage: "Välj språk",
    finnish: "Finska",
    danish: "Danska",
    english: "Engelska",
    swedish: "Svenska",
    norweigian: "Norska",
    german: "Tyska",
    japaneese: "Japanska",
    selectedLabel: "Vald etikett",
    dataManagement: "Datahantering",
    importData: "Importera data",
    exportData: "Exportera data",
    importExport: "Import / Export",
    exportProducts: "Exportera produkter",
    importProducts: "Importera produkter",
    selectFile: "Välj fil",
    upload: "Ladda upp",
    download: "Ladda ner",
    dataImportSuccess: "Data importerades",
    dataImportError: "Fel vid import av data",
    importProductsSubtitle: "Importera produkter från en xlsx-fil.",
    useCategories: "Visa kategorier",
    defaultLabel: "Standardetikett",
    defaultLabelHint: "Välj den etikett som är förvald vid utskrift.",
    noLabelsAvailable: "Inga etiketter tillgängliga",
    copy: "Kopia",
    useAliasAsTitle: "Använd alias som titel",
    useAliasAsTitleHint: "Använd fältet 'Alias' i stället för 'Produktnamn'. Om 'Alias' är tomt används 'Produktnamn'.",
    menus: "Menyer",
    locations: "Platser",
    deleteSelected: "Ta bort valda",
    confirmDeleteSelected: "Är du säker på att du vill ta bort {count} produkter?",
    create: "Skapa",
    createNewCategory: "Skapa ny kategori",
    nutritionProfile: "Näringsprofil",
    nutritionProfileHint: "Används av näringselementet på etiketter.",
    noNutritionProfiles: "Inga näringsprofiler ännu",
    days: "Dagar",
    hours: "Timmar",
    alias: "Alias",
    barcode: "Streckkod",

    // Label Designer
    labelDesigner: "Etikettdesigner",
    saveLabel: "Spara etikett",
    refresh: "Uppdatera",
    selectLabel: "Välj etikett",
    createNewLabel: "Skapa ny etikett",
    labelName: "Etikettnamn",
    width: "Bredd (mm)",
    height: "Höjd (mm)",
    titleFont: "Titelteckensnitt (pt)",
    titleX: "Titel X (mm)",
    titleY: "Titel Y (mm)",
    active: "Aktiv",
    addField: "Lägg till fält",
    fieldType: "Fälttyp",
    labelText: "Fälttext",
    baseDate: "Basdatum",
    offsetField: "Offsetfält",
    databaseField: "Databasfält",
    xPosition: "X-position (mm)",
    yPosition: "Y-position (mm)",
    fontSize: "Teckenstorlek (pt)",
    qrSize: "QR-kodens storlek (mm)",
    preview: "Förhandsgranskning",
    sampleItemName: "Exempel på produktnamn",
    size: "Storlek",
    scale: "Skala",
    fieldsCount: "Fält",
    newLabel: "Ny etikett",
    newField: "Nytt fält",
    labelSaved: "Etiketten sparad!",
    loadLabelsFailed: "Kunde inte läsa in etiketter",
    saveLabelFailed: "Kunde inte spara etiketten",
    labelPrinting: "Etikettutskrift",
    productsPerPage: "Objekt per sida",
    showAll: "Visa alla",
    selectAtLeastOne: "Välj minst ett objekt.",
    noLabelSelected: "Ingen etikett vald. Välj en i inställningarna.",
    labelColor: "Etikettfärg",
    creditZplImage: "ZPL-bildplugin utvecklad av: ",
    fieldTypePrompt: "Inmatningsfråga",
    promptDialogTitle: "Inmatning",

    // Label Type
    labelType: "Etiketttyp",
    labelTypeStandard: "Standard",
    labelTypeFreetext: "Fritext",
    freetextNotice: "Fritextetiketter är tomma fält för fri textinmatning på surfplattan. Inget produktnamn eller fördefinierade fält visas.",

    // Logo
    logo: "Logotyp",
    logoReplace: "Ersätt",
    logoUpload: "Ladda upp",
    logoRemove: "Ta bort",
    logoNoLogo: "Ingen logotyp uppladdad. Lägg till en för att placera den på etiketten.",
    logoUploadTitle: "Ladda upp logotyp",
    logoSelectFile: "Välj PNG-bild",
    logoSelectFileHint: "Ladda upp bilden redan roterad, precis som du vill ha den utskriven.",
    logoWidthOnLabel: "Bredd på etikett (mm)",
    logoWidthHint: "Höjden beräknas automatiskt",
    logoPrinterDpi: "Skrivarens DPI",
    logoOriginal: "Original",
    logoTarget: "Mål",
    logoBlackThreshold: "Svarttröskel",
    logoBlackThresholdHint: "Lägre = bara mörka pixlar blir svarta. Högre = även ljusare pixlar blir svarta.",
    logoPreviewOriginal: "Original",
    logoPreviewMono: "Monokrom (som utskrivet)",
    logoApply: "Använd",
    logoLoaded: "Logotyp inläst ({width}×{height}mm). Använd X/Y nedan för att placera den på etiketten.",
    logoNotUploaded: "Ingen logotyp uppladdad ännu. Gå till Etikettinställningar → Logotyp för att ladda upp en.",
    logoUploaded: "Logotypen uppladdad och konverterad",
    logoUploadFailed: "Kunde inte ladda upp logotypen",
    logoProcessFailed: "Kunde inte bearbeta logotypen",
    logoInvalidDimensions: "Ogiltiga mått",
    logoNoFile: "Ingen fil vald",

    // Field Types (dropdown titles)
    fieldTypeDate: "Datum",
    fieldTypeDatePlus: "Datum + dagar",
    fieldTypeDatabase: "Databasfält",
    fieldTypeQrcode: "QR-kod",
    fieldTypeBarcode: "Streckkod (Code128)",
    fieldTypeLogo: "Logotypbild",
    fieldTypeValueOnly: "Endast värde (flytande)",
    fieldTypeAllergensText: "Allergentext",
    fieldTypeStatic: "Statisk text",
    fieldTypeDivider: "Avdelare",

    // Value Only sub-types
    valueType: "Värdetyp",
    valueTypeDate: "Datum",
    valueTypeDatePlus: "Datum + dagar",
    valueTypeDatabase: "Databasfält",

    // Field position & size labels
    xMm: "X (mm)",
    yMm: "Y (mm)",
    rotation: "Rotation",

    // Separator & value position
    separator: "Avgränsare",
    separatorHint: "Text mellan etikett och värde. Lämna tomt för ingen avgränsare.",
    separatorPlaceholder: ": ",
    valueXMm: "Värde X (mm)",
    valueXHint: "Lämna tomt för att placera efter etiketten",
    valueYMm: "Värde Y (mm)",
    valueYHint: "Lämna tomt för att använda etikettens Y",
    valueFontSize: "Värdets teckenstorlek",
    valueFontSizeHint: "Lämna tomt för att använda etikettens storlek",

    // Font style
    bold: "Fet",
    italic: "Kursiv",

    // Text alignment
    textAlignment: "Textjustering",
    alignLeft: "Vänster",
    alignCenter: "Centrerad",
    alignRight: "Höger",

    // QR Code
    qrDataSource: "QR-datakälla",

    // Barcode
    barcodeDataSource: "Datakälla",
    barcodeWidthMm: "Streckkodens bredd (mm)",
    barcodeHeightMm: "Streckkodens höjd (mm)",
    barcodeDisplayValue: "Visa värdet under streckkoden",

    // Allergens text
    allergenSeparator: "Avgränsare",
    allergenSeparatorHint: "Tecken mellan allergennamn (t.ex. ', ' eller ' / ')",

    // Divider
    dividerLineWidth: "Linjebredd (mm)",
    dividerLineWidthHint: "Avdelarlinjens bredd",
    dividerLineThickness: "Linjetjocklek (mm)",
    dividerLineThicknessHint: "Linjens tjocklek",

    // Date Base
    
    // Database Fields
    fridgeValue: "Kylskåpsvärde",
    fridgeValueHint: "t.ex. FÖRE ÖPPNING",
    threeHours: "Tre timmar (JA/NEJ)",
    itemName: "Produktnamn",
    
    // Offset Fields
    thawingDaysOffset: "Upptiningsdagar",
    refrigeratedDaysOffset: "Kyldagar",
    expiryDays: "Hållbarhet (dagar)",
    thawingHours: "Upptiningstimmar",
    refrigeratedHours: "Kyltimmar",
    expiryHours: "Hållbarhet (timmar)",
    showTime: "Visa klockslag",
    
    // QR Data Fields
    itemId: "Produkt-ID",
    customUrl: "Anpassad URL",
    customData: "Anpassad data",

    // Snackbar / status messages
    labelSavedSuccess: "Etiketten sparad",
    labelSaveFailed: "Kunde inte spara etiketten",
    labelLoadFailed: "Kunde inte läsa in etiketter",
    labelLoadSingleFailed: "Kunde inte läsa in etiketten",
    fieldOrderUpdated: "Fältordningen uppdaterad",

    // Labels management view
    labelsDescription: "Hantera dina etiketter — visa detaljer, aktivera/inaktivera eller ta bort.",
    totalLabels: "Etiketter totalt",
    activeLabels: "Aktiva etiketter",
    inactiveLabels: "Inaktiva etiketter",
    labelsList: "Etiketter",
    searchLabels: "Sök bland etiketter...",
    dimensions: "Mått",
    inactive: "Inaktiv",
    color: "Färg",
    type: "Typ",
    freetext: "Fritext",
    viewLabel: "Visa etikett",
    noLabelsFound: "Inga etiketter hittades",
    createFirstLabel: "Skapa din första etikett",
    namePosition: "Namnets position",
    fieldLabel: "Fältnamn",
    position: "Position",
    noFields: "Inga fält konfigurerade",
    hasLogo: "Logotyp tillagd",
    status: "Status",
    editInDesigner: "Redigera i designern",
    confirmDeleteText: "Är du säker på att du vill ta bort '{labelName}'? Det går inte att ångra.",
    deleteWarning: "Alla fält som hör till etiketten tas också bort.",
    labelActivated: "'{name}' är nu aktiv",
    labelDeactivated: "'{name}' är nu inaktiv",
    labelToggleError: "Kunde inte ändra etikettens status",
    labelDeleted: "'{name}' har tagits bort",
    labelDeleteError: "Kunde inte ta bort etiketten",
    close: "Stäng",
    deleteLabel: "Ta bort etikett",

    // device management
    devicesDescription: "Hantera dina enheter och licenser.",
    totalLicenses: "Licenser totalt",
    usedLicenses: "Använda licenser",
    availableLicenses: "Lediga licenser",
    devicesList: "Enheter",
    searchDevices: "Sök bland enheter...",
    deleteDevice: "Ta bort enhet",
    noDevicesFound: "Inga enheter hittades",
    noDevicesHint: "Enheter registreras via appen.",
    deleteDeviceHint: "Enheten måste registreras igen innan den kan användas.",
    deviceDeleted: "'{name}' har tagits bort",
    deviceDeleteError: "Kunde inte ta bort enheten",
    canEdit: "Kan redigera",
    cannotEdit: "Kan inte redigera",
    canEditProducts: "Redigering",
    allowEditing: "Tillåt redigering",
    disableEditing: "Inaktivera redigering",
    editingEnabled: "Redigering aktiverad",
    editingDisabled: "Redigering inaktiverad",
    selected: "valda",
    updateError: "Uppdateringen misslyckades",
    canDelete: "Kan ta bort",
    cannotDelete: "Kan inte ta bort",
    canDeleteProducts: "Borttagning",
    allowDeleting: "Tillåt borttagning",
    disableDeleting: "Inaktivera borttagning",
    deletingEnabled: "Borttagning aktiverad",
    deletingDisabled: "Borttagning inaktiverad",
    editingDisabledCascade: "Redigering inaktiverad — borttagning inaktiverades också",
    deletingEnabledCascade: "Borttagning aktiverad — redigering aktiverades också",
    allowBackdating: "Tillåt bakåtdatering",
    disallowBackdating: "Inaktivera bakåtdatering",
    backdatingEnabled: "Bakåtdatering aktiverad",
    backdatingDisabled: "Bakåtdatering inaktiverad",
    backdatingDisabledCascade: "Bakåtdatering inaktiverad — redigering inaktiverades också",
    backdatingEnabledCascade: "Bakåtdatering aktiverad — redigering aktiverades också",
    backdatingOff: "Bakåtdatering inaktiverad",
    backdatingOn: "Bakåtdatering aktiverad",
    maxBackdateDays: "Högsta antal dagar för bakåtdatering",
    maxBackdateDaysHint: "Ange hur många dagar bakåt en användare får välja för tillverknings-/öppningsdatum. 0 inaktiverar bakåtdatering.",

    // Configurations Page
    configurations: "Konfigurationer",
    globalSettings: "Globala inställningar",
    globalSettingsHint: "De här inställningarna gäller alla surfplattor på kontot. När du sparar höjs versionen så att plattorna hämtar de nya inställningarna.",
    tabletFields: "Surfplattefält",
    tabletFieldConfig: "Konfiguration av surfplattefält",
    tabletFieldConfigHint: "Konfigurera vilka fält som visas när objekt skapas eller redigeras på surfplattor.",
    tabletFieldConfigInfo: "Dra för att ändra ordning. Dolda fält visas inte i surfplattans dialoger. Obligatoriska fält måste fyllas i före sparande.",
    freetextLabels: "Fritextetiketter",
    freetextLabelsOverview: "Fritextetiketter",
    freetextLabelsHint: "Alla fritextetiketter inklusive lokala surfplatteetiketter. Lokala etiketter visas bara på enheten som skapade dem.",
    noFreetextLabels: "Inga fritextetiketter hittades.",
    reassignToDevice: "Tilldela till enhet",
    reassignHint: "Välj en enhet att tilldela fritextetiketten till. Den visas då inte längre på den ursprungliga enheten.",
    labelsSelected: "{count} etikett(er) valda",
    targetDevice: "Målenhet",
    markAsLocal: "Markera som lokal",
    reassign: "Tilldela",
    moveToDevice: "Flytta till enhet",
    removeFromAll: "Ta bort från alla enheter",
    broadcastNewLabel: "Sänd en ny etikett till flera enheter",
    broadcastNew: "Skapa ny",
    broadcast: "Publicera",
    freetextContent: "Fritextinnehåll",
    selectAll: "Välj alla",
    deselectAll: "Avmarkera alla",
    selectDevices: "Välj enheter",
    broadcastDevices: "Skicka till {count}",
    devicesSelected: "{count} enhet(er) valda",
    pushToDevices: "Skicka till {count} enheter",
    pushExistingHint: "Skicka en befintlig etikett till flera enheter.",
    activeBroadcasts: "Aktiva sändningar",
    broadcastsHint: "Fritextetiketter som just nu sänds till flera enheter. De förblir aktiva tills de tas bort manuellt från alla enheter eller tilldelas en enskild enhet.",
    noBroadcasts: "Inga aktiva sändningar",
    valuesInDays: "dagar",
    valuesInHours: "timmar",
    showAlias: "Visa alias",
    showAliasHint: "Visa fältet 'Alias' på surfplattans startskärm under produktnamnet.",
    showMenuTab: "Visa menyflik",
    showMenuTabHint: "Visa den aktiva menyn som en flik på surfplattans startskärm",
    hideCategoryAll: "Dölj kategorin 'Alla'",
    hideCategoryAllHint: "Dölj kategorin 'Alla' i kategorimenyn på surfplattor",

    // Global Settings Toggles
    useCategoriesHint: "Visa kategorimenyn på surfplattor och kategorival när objekt skapas",
    usePrintDialog: "Visa utskriftsdialog",
    usePrintDialogHint: "Visa en dialog med datumval innan etiketter skrivs ut på surfplattor",
    showTimestampOnDates: "Visa klockslag på datum",
    showTimestampOnDatesHint: "Inkludera tidsstämpel TT:MM på datumetiketter (t.ex. 17/02/26 10:30)",
    showCategoryOnProduct: "Visa kategori på produkt",
    showCategoryOnProductHint: "Visa kategorinamnet under produktnamnet på surfplattans startskärm",
    todaysDateInclusive: "Dagens datum inkluderat",
    todaysDateInclusiveHint: "Räkna med dagens datum i utgångsberäkningen (t.ex. 3 dagar från måndag = onsdag i stället för torsdag)",
    settingsVersionInfo: "Aktuell version",
    settingsVersionHint: "Surfplattor med en äldre version hämtar de uppdaterade inställningarna vid nästa uppdatering.",
    saveChanges: "Spara ändringar",

    // Field Config Table
    fieldName: "Fält",
    customLabel: "Anpassad etikett",
    visible: "Synlig",
    required: "Obligatorisk",

    // Freetext Table
    content: "Innehåll",
    device: "Enhet",
    scope: "Omfattning",
    updated: "Uppdaterad",
    local: "Lokal",
    global: "Global",
    confirmDeleteFreetext: "Är du säker på att du vill ta bort den här fritextetiketten?",
    freetextSizes: "Tillgängliga storlekar",
    freetextSizesHint: "Lista över tillgängliga fritextstorlekar.",
    createSize: "Skapa storlek",
    createFreetextSize: "Skapa fritextstorlek",
    widthMm: "Bredd (mm)",
    heightMm: "Höjd (mm)",
    freetextSizeWhiteHint: "Fritextetiketter visas som vita",
    default: "Standard",
    setAsDefault: "Ange som standard",
    cancelDefault: "Ta bort standard",

    // Location management
    locationName: "Platsens namn",
    assignUser: "Tilldela användare",
    assignedUsers: "Tilldelade användare",
    noUsersAssigned: "Inga användare tilldelade",
    addUsers: "Lägg till användare",
    selectUsers: "Välj användare",
    assignProducts: "Tilldela produkter",
    assignedProducts: "Tilldelade produkter",
    availableProducts: "Tillgängliga produkter",
    noProductsAssigned: "Inga produkter tilldelade",
    allProductsAssigned: "Alla produkter tilldelade",
    countryCode: "Landskod",
    timezone: "Tidszon",
    createdLocation: "Platsen skapad",
    editLocation: "Redigera plats",
    totalLabelsPrinted: "Totalt antal utskrivna etiketter",
    clickForBreakdown: "Klicka för en detaljerad uppdelning",
    printStatsTitle: "Utskriftsstatistik",
    noPrintEvents: "Ingen utskriftsstatistik hittades för några platser",
    labelsPrintedTotal: "etiketter utskrivna totalt",
    since: "sedan",
    createLocation: "Skapa plats",

    //Tickets System
    createTicket: "Skapa ärende",
    ticketType: "Ärendetyp",
    ticketTypeSale: "Försäljning",
    ticketTypeSupport: "Support",
    ticketTypeBug: "Felrapport",
    ticketTitle: "Titel",
    ticketDescriptionHint: "Beskriv ditt problem eller din förfrågan i detalj",
    ticketReporter: "Rapportör",
    ticketCreated: "Ärendet skapat",
    priority: "Prioritet",
    priorityHint: "Lämna tomt och låt systemet avgöra utifrån ärendets innehåll, eller välj manuellt",
    priorityAuto: "Auto",
    priorityLow: "Låg",
    priorityMedium: "Medel",
    priorityHigh: "Hög",
    priorityUrgent: "Brådskande",
    submit: "Skicka ärende",
    tickets: "Ärenden",
    orderAccessories: "Beställ etiketter och tillbehör",
    ticketLogHint: "Lista över supportärenden skickade till Capture IT.",

    impersonation: {
        menuItem: "Gå in som kund",
        title: "Gå in som kund",
        subtitle: "Välj en kund för att arbeta i deras konto. Allt du gör sker med deras riktiga data.",
        search: "Sök på kund, kontonummer eller e-post...",
        customer: "Kund",
        lastPrint: "Senast utskrivet",
        enter: "Gå in",
        noCustomers: "Inga kunder hittades",
        loadFailed: "Kunde inte hämta kundlistan",
        confirmTitle: "Gå in i kundens konto?",
        confirmText: "Du är på väg att öppna {customer}s konto med deras egen administratörs behörighet.",
        confirmWarning: "Allt du gör sker med kundens riktiga data. Sessionen loggas och upphör automatiskt efter 2 timmar.",
        bannerTitle: "Du arbetar i {customer}s konto",
        bannerSubtitle: "Inloggad som dig själv ({user}) bakom",
        stop: "Avsluta",
        actions: "Åtgärder",
    },

    designer: {
        untitled: "Namnlös",
        noLabel: "Ingen etikett vald",
        saved: "Sparad",
        saveError: "Kunde inte spara",
        unsavedTitle: "Osparade ändringar",
        unsavedConfirm: "Du har osparade ändringar. Vill du lämna sidan?",
        leaveAnyway: "Lämna ändå",
        stay: "Stanna",
        toggleGrid: "Växla rutnät",
        preview: "Förhandsgranskning",
        undo: "Ångra",
        redo: "Gör om",
        save: "Spara",
        print: "Skriv ut",
        back: "Tillbaka",
    },
    fields: {
        productFields: "Produktfält",
        productField: "Produktfält",
        barcodes: "Streckkoder",
        layout: "Layout",
        qrCode: "QR-kod",
        staticText: "Statisk text",
        imageLogo: "Logotypbild",
        divider: "Avdelare",
        productNumber: "Produktnummer",
        productName: "Produktnamn",
        description: "Beskrivning",
        costPrice: "Inköpspris",
        salesPrice: "Försäljningspris",
        currency: "Valuta",
    },
    common: {
        none: "Ingen",
        save: "Spara",
        cancel: "Avbryt",
        delete: "Ta bort",
        close: "Stäng",
        edit: "Redigera",
        copy: "Kopiera",
        unsaved: "Osparade ändringar",
        loading: "Läser in...",
        error: "Fel",
        success: "Klart",
    },
    label: {
        name: "Etikettnamn",
        width: "Bredd (mm)",
        height: "Höjd (mm)",
        color: "Färg",
        colour: "Färg",
        type: "Typ",
        grid: "Rutnät",
        gridSize: "Rutnätsstorlek (mm)",
        active: "Aktiv",
        unit: "Enhet",
        mm: "mm",
        inch: "tum",
    },
    canvas: {
        grid: "Visa rutnät",
        gridSize: "Rutnätsstorlek (mm)",
        layers: "Lager",
        noElements: "Inga element",
    },
    importFromOld: "Importera från det gamla systemet",
    selectLabelsToImport: "Välj etiketter att importera",
    importHint: "Etiketterna importeras till det nya systemet. Originalet behålls.",
    importCount: "Importera {n} etikett(er)",
    newDesign: "Ny etikett",
    designs: "Etiketter",
    searchDesigns: "Sök bland etiketter...",
    totalDesigns: "Etiketter totalt",
    activeDesigns: "Aktiva etiketter",
    inactiveDesigns: "Inaktiva etiketter",
    designCreated: "Etiketten skapad",
    designCopied: "Etiketten kopierad",
    designDeleted: "Etiketten borttagen",
    designsDeleted: "Etiketterna borttagna",
    deleteDesign: "Ta bort etikett",
    deleteDesignConfirm: "Är du säker på att du vill ta bort '{name}'?",
    bulkDelete: "Ta bort valda",
    bulkDeleteConfirm: "Är du säker på att du vill ta bort {n} etiketter?",
    errorCreating: "Kunde inte skapa etiketten",
    errorUpdating: "Kunde inte uppdatera etiketten",
    errorCopying: "Kunde inte kopiera etiketten",
    errorDeleting: "Kunde inte ta bort etiketten",
    errorLoading: "Kunde inte läsa in etiketter",
    importSuccess: "{n} etikett(er) importerade",
    importError: "Fel vid import",
    labelsSubtitle: "Hantera dina etiketter",
    roundExpiryDownToQuarter: "Avrunda utgångstiden nedåt till närmaste kvart",
    roundExpiryDownToQuarterHint: "Endast när hållbarheten anges i timmar. En utgång 16:07 visas som 16:00 — alltid nedåt, så hållbarheten aldrig överskrids",
    // Shown on the colour swatch in the product list when the
    // product prints with something other than its own label.
    labelInactiveFallback: "Etiketten \"{label}\" är inaktiv — skriver ut med \"{fallback}\"",
    labelMissingFallback: "Ingen etikett vald — skriver ut med \"{fallback}\"",

    // Bulk deletion of categories, including the "these still
    // contain products — move them where?" second step.
    confirmBulkDeleteCategories: "Ta bort de valda kategorierna?",
    bulkDeleteWarning: "Åtgärden kan inte ångras.",
    categoriesInUseTitle: "Kategorierna används",
    categoriesInUseText: "Följande kategorier innehåller fortfarande varor:",
    moveProductsTo: "Flytta varorna till",
    moveAndDelete: "Flytta och ta bort",
    noReassignTarget: "Alla kategorier är valda. Avmarkera minst en att flytta varorna till.",
    categoriesDeleted: "kategorier borttagna",
    productsMoved: "varor flyttade",
    defaultCategorySkipped: "standardkategorin hoppades över",
    bulkDeleteFailed: "Borttagningen misslyckades",

    totalLocations: "Platser totalt",

    productImage: "Produktbild",
    chooseFromLibrary: "Välj från bibliotek",
    changeImage: "Byt bild",
    productImageHint: "Visas på surfplattan i stället för produktnamnet, om bildvisning är påslagen",
    productImageLibrary: "Bildbibliotek",

    productImages: {
        libraryTitle: "Bildbibliotek",
        libraryHint: "Ladda upp alla produktbilder på en gång och välj in dem på varorna efteråt.",
        uploadButton: "Ladda upp bilder",
        deleteSelected: "Ta bort valda",
        uploadProgress: "Laddar upp",
        alreadyInLibrary: "Finns redan i biblioteket",
        noImages: "Inga bilder ännu",
        preview: "Förhandsvisning",
        name: "Namn",
        dimensions: "Mått",
        usedBy: "Används av",
        uploaded: "Uppladdad",
        uploadSummary: "{n} bilder uppladdade",
        uploadSummaryFailed: "{n} uppladdade, {failed} misslyckades",
        uploadSummaryDuplicates: "{n} uppladdade, {duplicates} överhoppade som dubbletter",
        imageRenamed: "Bilden har bytt namn",
        renameFailed: "Kunde inte byta namn på bilden",
        confirmDeleteImage: "Är du säker på att du vill ta bort den här bilden?",
        deleteImageInUseWarning: "{n} varor använder den här bilden och förlorar den.",
        imageDeleted: "Bilden borttagen",
        imageDeletedInUse: "Bilden borttagen — varorna som använde den saknar nu bild",
        deleteFailed: "Kunde inte ta bort bilden",
        confirmBulkDelete: "Bekräfta borttagning",
        confirmBulkDeleteText: "Är du säker på att du vill ta bort {n} bilder?",
        selectedInUseWarning: "{n} av de valda bilderna används och försvinner från de varor som använder dem.",
        andMoreCount: "… och {n} till",
        deleteAll: "Ta bort alla",
        imagesDeletedSummary: "{n} bilder borttagna",
        imagesDeletedMissing: "{n} bilder borttagna ({missing} hittades inte)",
        bulkDeleteFailed: "Kunde inte ta bort bilderna",

        picker: {
            title: "Välj bild",
            uploadNew: "Ladda upp nya",
            search: "Sök bland bilder...",
            empty: "Det finns inga bilder i biblioteket ännu. Ladda upp några för att komma igång.",
            noMatch: "Inga bilder matchar sökningen",
            removeImage: "Ta bort bild",
            uploadFailedCount: "{n} bilder kunde inte laddas upp",
        },
    },
    showProductImages: "Visa produktbilder",
    showProductImagesHint: "Visa produktbilder på surfplattans startskärm.",
    showProductNames: "Visa produktnamn",
    showProductNamesHint: "Visa produktnamn på surfplattans startskärm.",

    productDisplayMode: "Produktvisning",
    displayModeText: "Namn",
    displayModeImage: "Bilder",
    displayModeUser: "Användarens val",
    mixed: "Blandat",
    noDevicesUpdated: "Inga enheter uppdaterades",
    customFields: "Anpassade fält",
    customFieldsHint: "Lägg till fält för att visa specifik produktinformation",
    noCustomFields: "Inga anpassade fält",
    editField: "Redigera fält",
    fieldLabelHint: "Etikett för fältet",
    fieldPrefixHint: "Prefix för fältet",
    fieldKeyFixedHint: "Nyckel för fältet (kan inte ändras)",
    deleteFields: "Ta bort fält",
    deleteFieldsWarning: "Detta tar bort de valda fälten permanent",
    deactivateInsteadHint: "Inaktivera i stället för att ta bort",
    fieldsDeleted: "Fälten borttagna",
    valuesRemoved: "Värdena borttagna",
    storedValues: "Sparade värden",
    printedPrefix: "Utskrivet prefix",
    prefix: "Prefix",
    fieldKey: "Fältnyckel",
    values: "Värden",
    sortOrder: "Sorteringsordning",
    labelRequired: "Etikett är obligatoriskt",

    ...designerI18n.sv,
}